<div class="row">
  <div class="col-md-12">
    <!-- <div class="card">
    <div class="card-body"> -->
    <div class="table-responsive">
      <table class="table">
        <thead *ngIf="!hideHeader">
          <tr *ngIf="parentHeader.length">
            <ng-container *ngFor="let head of parentHeader">
              <th [attr.colspan]="head.colspan">{{ head.name | translate }}</th>
            </ng-container>
          </tr>
          <tr *ngIf="!hideHeader">
            <th *ngIf="isSelectable">
              <ng-container *ngIf="isSelectable && hasSelectAll; else selectText">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [indeterminate]="dataSetNotAllSelected()"
                  [checked]="dataSetAllSelected()"
                  (change)="onSelectAll($event)"
                />
              </ng-container>
              <ng-template #selectText>
                {{ 'Select' | translate }}
              </ng-template>
            </th>
            <ng-container *ngFor="let col of columns">
              <th
                *ngIf="!col.hide"
                (click)="sort(col)"
                [ngStyle]="{ 'text-align': col.align }"
                [ngClass]="{ clickable: col.sortable }"
              >
                <span [class]="col.headerClass"> {{ col.name | translate }}</span>
                <i
                  *ngIf="col.sortable && col.field === key"
                  class="pi"
                  [ngClass]="{
                    'pi-sort-amount-down': reverse,
                    'pi-sort-amount-down-alt': !reverse
                  }"
                ></i>
                <i *ngIf="col.sortable && col.field !== key" class="pi pi-sort-alt"></i>
              </th>
            </ng-container>
            <ng-container *ngIf="actions && actions.length > 0">
              <th [ngStyle]="{ 'text-align': 'center' }">
                {{ 'Actions' | translate }}
              </th>
            </ng-container>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of dataset; let i = index" [ngClass]="{ 'no-border': !isPaginated }">
            <td *ngIf="isSelectable">
              <ng-container *ngIf="data['isSelectable'] != undefined; else checkBoxElse">
                <input
                  *ngIf="data['isSelectable']"
                  class="form-check-input"
                  type="checkbox"
                  [indeterminate]
                  [checked]="data.isSelected"
                  [value]="data.isSelected"
                  (change)="onSelectChanged($event, i, data)"
                />
              </ng-container>
              <ng-template #checkBoxElse>
                <input
                  class="form-check-input"
                  type="checkbox"
                  [indeterminate]
                  [checked]="data.isSelected"
                  [value]="data.isSelected"
                  (change)="onSelectChanged($event, i, data)"
                />
              </ng-template>
            </td>
            <ng-container *ngFor="let col of columns">
              <td
                *ngIf="!col.hide"
                [ngStyle]="{ 'text-align': col.align }"
                [style]="col.setStyles ? col.setStyles(data) : ''"
              >
                <span
                  *ngIf="col.isCustome && col.customValue"
                  (click)="col.click ? col.click(data) : null"
                  [ngClass]="{ clickable: !!col.click }"
                  [innerHTML]="col.customValue(data)"
                ></span>
                <span
                  *ngIf="!(col.isCustome || col.customValue) && !col.toggleBtnOptions"
                  (click)="col.click ? col.click(data) : null"
                  [ngClass]="{ clickable: !!col.click }"
                >
                  {{
                    col.isPrice && isNumber(data[col.field])
                      ? (data[col.field] | number: '1.0-3')
                      : (data[col.field] | translate)
                  }}
                  {{ col.currency ? ('sar' | translate) : '' }}
                </span>

                <!-- form -->
                <span
                  *ngIf="!(col.isCustome || col.customValue) && col.toggleBtnOptions"
                  (click)="col.click ? col.click(data) : null"
                  [ngClass]="{ clickable: !!col.click }"
                >
                  <div class="mb-3 col-12 form-switch custom-toggle-switch">
                    <div class="form-check fix-field-align">
                      <input
                        (change)="toggleSwitchChange($event, data)"
                        [checked]="col?.toggleBtnOptions?.isChecked(data)"
                        [disabled]="col?.toggleBtnOptions?.isDisabled(data)"
                        type="checkbox"
                        class="form-check-input"
                      />
                    </div>
                  </div>
                </span>
              </td>
            </ng-container>

            <ng-container *ngIf="actions && actions.length > 0">
              <td
                class="text-center"
                *ngIf="!hideActionIfNotExist || (hideActionIfNotExist && data[hideActionIfNotExist])"
              >
                <div
                  ngbDropdown
                  container="body"
                  [placement]="translateService.currentLang == 'ar' ? 'bottom-left' : 'bottom-right'"
                >
                  <button
                    [disabled]="hasDropdownActions(actions, data)"
                    class="btn btn-sm btn-light"
                    id="dropdownBasic1"
                    ngbDropdownToggle
                  >
                    <i class="pi pi-ellipsis-h"></i>
                  </button>
                  <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                    <ng-container *ngFor="let action of actions">
                      <div [ngClass]="{ 'd-none': action.isDisable && action?.isDisable(data) }">
                        <span
                          [disabled]="(action.isDisable && action?.isDisable(data)) ?? false"
                          class="clickable"
                          ngbDropdownItem
                          *ngIf="!(action.isCustom || action.customValue)"
                          (click)="onActionClicked(action.name, data)"
                        >
                          <i [class]="action.icon"></i>
                          {{ action.text || action.name | translate }}
                        </span>
                        <span
                          class="clickable"
                          [disabled]="(action.isDisable && action?.isDisable(data)) ?? false"
                          ngbDropdownItem
                          *ngIf="action.isCustom && action.customValue"
                          (click)="onActionClicked(action.name, data)"
                          [innerHTML]="action.customValue(data, action)"
                        ></span>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </td>
            </ng-container>
          </tr>
        </tbody>
      </table>
      <ng-content *ngIf="hasTotalTemplate" select="[totalTemplate]"></ng-content>

      <div *ngIf="isPaginated" class="d-flex flex-wrap align-items-center justify-content-between p-2">
        <ngb-pagination
          [maxSize]="5"
          [collectionSize]="paginationData.totalPages * pageSize"
          [(page)]="page"
          [pageSize]="pageSize"
          (pageChange)="loadPage($event)"
        >
        </ngb-pagination>

        <ng-container *ngIf="!hideShowingEntries">
          <div class="size">
            <span
              >{{ 'showing' | translate }} {{ (page - 1) * pageSize + 1 }}

              {{ 'to' | translate }} {{ page * pageSize }} {{ 'of total' | translate }}
              {{ paginationData.totalRecord ?? dataset.length }} {{ 'entries' | translate }}</span
            >
          </div>

          <div class="col-2 d-flex align-items-center">
            <!-- <div class="card"> -->
            <ng-select
              [appendTo]="appendTo"
              [clearable]="false"
              [items]="optionsSizes"
              [ngModel]="pageSize"
              (ngModelChange)="limitChange($event)"
            >
            </ng-select>
            <!-- </div> -->
          </div>
          <!-- col -->
        </ng-container>
      </div>
    </div>
    <!-- </div>
  </div> -->
  </div>
</div>
